import React from "react";
import { FiFileText, FiImage, FiX } from "react-icons/fi";

const closedState = {
  open: false,
  title: "",
  files: [],
  selectedIndex: 0,
};

const TravelExpenseReceiptPreviewModal = ({
  modalState,
  setModalState,
  onOpenInNewTab,
}) => {
  if (!modalState.open) return null;

  const selectedFile = modalState.files[modalState.selectedIndex];

  return (
    <div className="fixed inset-0 z-[100] bg-black/50 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="w-full max-w-5xl rounded-3xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 dark:border-gray-700">
          <div>
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
              หลักฐานค่าเดินทาง
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {modalState.title}
            </p>
          </div>
          <button
            type="button"
            onClick={() => setModalState(closedState)}
            className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700"
          >
            <FiX size={18} />
          </button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_280px]">
          <div className="p-5 bg-gray-50 dark:bg-gray-950/60 min-h-[420px]">
            <div className="rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 overflow-hidden min-h-[380px] flex items-center justify-center">
              {selectedFile?.type === "pdf" ? (
                <div className="w-full h-[70vh] min-h-[380px]">
                  <iframe
                    title={selectedFile.label}
                    src={selectedFile.signedUrl}
                    className="w-full h-full"
                  />
                </div>
              ) : (
                <img
                  src={selectedFile?.signedUrl}
                  alt={selectedFile?.label}
                  className="max-h-[70vh] w-full object-contain bg-gray-50 dark:bg-gray-950/60"
                />
              )}
            </div>

            <div className="mt-4 flex items-center justify-between gap-3">
              <div className="text-sm text-gray-500 dark:text-gray-400">
                {selectedFile?.label}
              </div>
              <button
                type="button"
                onClick={() => onOpenInNewTab(selectedFile?.signedUrl)}
                className="px-3 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium"
              >
                เปิดในแท็บใหม่
              </button>
            </div>
          </div>

          <div className="border-t lg:border-t-0 lg:border-l border-gray-200 dark:border-gray-700 p-4 bg-white dark:bg-gray-900">
            <div className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-3">
              ไฟล์ทั้งหมด {modalState.files.length} รายการ
            </div>
            <div className="space-y-3 max-h-[70vh] overflow-y-auto pr-1">
              {modalState.files.map((file, index) => (
                <button
                  key={file.originalUrl}
                  type="button"
                  onClick={() =>
                    setModalState((prev) => ({
                      ...prev,
                      selectedIndex: index,
                    }))
                  }
                  className={`w-full rounded-2xl border p-3 text-left transition ${
                    modalState.selectedIndex === index
                      ? "border-cyan-400 bg-cyan-50 dark:bg-cyan-900/20 dark:border-cyan-700"
                      : "border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800/50 hover:bg-gray-100 dark:hover:bg-gray-800"
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700">
                      {file.type === "pdf" ? (
                        <FiFileText className="text-rose-500" size={18} />
                      ) : (
                        <FiImage
                          className="text-cyan-600 dark:text-cyan-300"
                          size={18}
                        />
                      )}
                    </div>
                    <div className="min-w-0">
                      <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                        ไฟล์ที่ {index + 1}
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400 truncate">
                        {file.label}
                      </div>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelExpenseReceiptPreviewModal;